import React from 'react';

import CartView from '../components/CartView';

const Cart = () => (
  <div>
    <h1>Cart</h1>
    <CartView />
  </div>
);

export default Cart;
